import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useIntl } from 'react-intl';

import { SCIApi } from 'src/apis';

import {
    PaymentSurchargeResponse,
    PaymentSurchargePayload,
} from '../payment.type';
import { paymentSurcharge } from '../payment.api';
import { backendError } from '../payment.messages';

const postPaymentSurcharge = async (payload: PaymentSurchargePayload) => {
    const apiCalls = SCIApi.getInstance();
    const result: AxiosResponse<PaymentSurchargeResponse> =
        await apiCalls.post<PaymentSurchargeResponse>(
            paymentSurcharge,
            payload,
        );

    return result?.data ?? result;
};

export const usePaymentSurcharge = () => {
    const intl = useIntl();
    const genericErrorMessage = intl.formatMessage(backendError.generic);

    const [error, setError] = useState<React.ReactNode | string | undefined>(
        undefined,
    );

    const { mutate, isLoading, isError, data } = useMutation(
        postPaymentSurcharge,
        {
            onError: () => setError(genericErrorMessage),
        },
    );

    return {
        mutate,
        isLoading,
        isError,
        data,
        error,
    };
};
